import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const WatchSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 12}
    height={props.width ? props.width : 12}
    fill="none"
    className="relative top-[2px] inline md:w-5 md:h-5"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeWidth={0.705}
      d="M11.334 5.668a5.286 5.286 0 1 1-10.572 0 5.286 5.286 0 0 1 10.572 0Z"
    />
    <path
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeWidth={0.705}
      d="M4.873 4.149a.587.587 0 0 1 1.003-.415l1.518 1.518c.23.23.23.602 0 .83l-1.518 1.52a.587.587 0 0 1-1.003-.416V4.15Z"
    />
  </svg>
)
export default WatchSVG
